"use strict";

exports.__esModule = true;
exports.unionWeeklyAvailabilities = unionWeeklyAvailabilities;
exports.unionAvailabilityExceptions = unionAvailabilityExceptions;

var _lodash = _interopRequireDefault(require("lodash"));

var _availability = require("availability");

var _intervalUtils = require("interval-utils");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unionWeeklyAvailabilities(availabilities) {
  if (availabilities.some(alwaysAvailable)) {
    return {
      weekly: [{
        minuteOfWeek: 0,
        durationMins: 10080
      }]
    };
  }

  const intervals = availabilities.map(availabilityToWeekly).map(weeklyAvailabilityToIntervals);
  const unionizedInterval = (0, _intervalUtils.unionIntervals)(...intervals);
  return {
    weekly: intervalsToAvailability(unionizedInterval)
  };
}

function unionAvailabilityExceptions(availabilities) {
  return availabilities.flatMap(a => a.exceptions || []).filter(Boolean);
}

function availabilityToWeekly(availability) {
  return availability && availability.weekly ? availability.weekly : [];
}

function weeklyAvailabilityToIntervals(weekly) {
  return _lodash.default.map(weekly, availabilityRangeToInterval);
}

function availabilityRangeToInterval({
  minuteOfWeek,
  durationMins
}) {
  return [minuteOfWeek, minuteOfWeek + durationMins];
}

function intervalsToAvailability(intervals) {
  return _lodash.default.map(intervals, ([from, to]) => ({
    minuteOfWeek: from,
    durationMins: to - from
  }));
}

function alwaysAvailable(availability) {
  return typeof availability.weekly === 'undefined' || (0, _availability.isAlwaysAvailable)(new _availability.AvailabilityIterator({
    availability,
    cal: (0, _moment.default)()
  }));
}
//# sourceMappingURL=unionAvailabilites.js.map